var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QueryHome',{scopedSlots:_vm._u([{key:"default",fn:function({ entry, heroImage }){return [_c('TemplateDefault',[_c('BaseHero',{staticClass:"hero--home",attrs:{"image":heroImage}}),_vm._v(" "),(entry.flexibleSections)?_c('FlexibleSections',{attrs:{"sections":entry.flexibleSections}}):_vm._e()],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }